import { render, staticRenderFns } from "./InstitutionViewInstitutionInfoCard.vue?vue&type=template&id=24ef6d55&"
import script from "./InstitutionViewInstitutionInfoCard.vue?vue&type=script&lang=js&"
export * from "./InstitutionViewInstitutionInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports